import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock } from 'lucide-react';
import { buildMarketingUrl } from '@/lib/workspace';
import type { Account } from '@/types/icrop';

interface WorkspaceExpiredPageProps {
  account: Account;
}

export function WorkspaceExpiredPage({ account }: WorkspaceExpiredPageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <Clock className="h-12 w-12 text-orange-500" />
          </div>
          <CardTitle className="text-2xl">Trial expired</CardTitle>
          <CardDescription>
            The trial for <strong>{account.name}</strong> has ended. Contact your account
            administrator or iCrop support to convert to a paid plan and regain access.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild variant="outline">
            <a href={buildMarketingUrl()}>Back to iCrop.net</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
